export default {
    latestVersionData: {},
    showDialog: false
}
